<template>
  <div>
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <div v-if="!loading">
      <div v-if="branch" class="flex flex-col">
        <div class="card">
          <div class="flex justify-between items-center">
            <p class="font-medium">ID: #{{ branch.id }}</p>

            <div class="flex space-x-4 items-center">
              <router-link
                v-if="hasPermission('edit_branches')"
                :to="{
                  name: 'branchesEditForm',
                  params: { id: branch.id },
                }"
              >
                <edit-button />
              </router-link>

              <delete-button
                v-if="hasPermission('delete_branches')"
                class="delete-icon-button"
                @click.prevent="openDeleteModal()"
              />
            </div>
            <!-- <options-menu
              v-if="getOptions().length > 0"
              :options="getOptions()"
              @edit="
                $store.commit('pushRouteToBreadcrumbs', {
                  route: $route.name,
                  params: $route.params,
                  display_name: branch.name,
                });
                $router.push({
                  name: 'branchesEditForm',
                  params: { id: branch.id },
                });
              "
              @delete="openDeleteModal()"
            /> -->
          </div>

          <div class="div-line"></div>

          <div
            class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 text-sm mt-2"
          >
            <div>
              <p class="font-medium">Nombre</p>
              <p>{{ branch.name }}</p>
            </div>

            <div>
              <p class="font-medium">Franquicia</p>
              <router-link
                :to="{
                  name: 'franchisesDetail',
                  params: { id: branch.franchise.id },
                }"
                class="underline"
                >{{ branch.franchise.name }}</router-link
              >
            </div>

            <div>
              <p class="font-medium">Precio default por envió</p>
              <p>
                {{ integerToCurrency(branch.local_delivery_default_price) }}
              </p>
            </div>

            <div>
              <p class="font-medium">Peso máximo por envío</p>
              <p>
                {{
                  branch.local_delivery_max_weight
                    ? branch.local_delivery_max_weight
                    : "-"
                }}
              </p>
            </div>

            <div>
              <p class="font-medium">Recoger en sucursal habilitado</p>
              <p>{{ branch.pickup_delivery ? "Sí" : "No" }}</p>
            </div>

            <div>
              <p class="font-medium">Calle</p>
              <p>{{ branch.address.street }}</p>
            </div>

            <div>
              <p class="font-medium">Número Exterior</p>
              <p>{{ branch.address.exterior_number }}</p>
            </div>

            <div>
              <p class="font-medium">Número Interior</p>
              <p>
                {{
                  branch.address.interior_number
                    ? branch.address.interior_number
                    : "-"
                }}
              </p>
            </div>

            <div>
              <p class="font-medium">Colonia</p>
              <p>
                {{
                  branch.address.neighborhood
                    ? branch.address.neighborhood
                    : "-"
                }}
              </p>
            </div>

            <div>
              <p class="font-medium">Ciudad</p>
              <p>{{ branch.address.city ? branch.address.city : "-" }}</p>
            </div>

            <div>
              <p class="font-medium">Estado</p>
              <p>{{ branch.address.state ? branch.address.state.name : "-" }}</p>
            </div>

            <div>
              <p class="font-medium">Código Postal</p>
              <p>
                {{ branch.address.zip_code ? branch.address.zip_code : "-" }}
              </p>
            </div>

            <div>
              <p class="font-medium">Rango de envío local</p>
              <p>
                {{ branch.max_distance }} km
              </p>
            </div>

            <div>
              <p class="font-medium">Fecha de creación</p>
              <p>{{ formatDatetime(branch.created_at) }}</p>
            </div>

            <div>
              <p class="font-medium">Fecha de última actualización</p>
              <p>{{ formatDatetime(branch.updated_at) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import validationErrors from "@/mixins/validationErrors";
import { formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Branch Detail",

  data() {
    return {
      branch: null,
      loading: false,
      loadingForm: false,
      loadingDelete: false,
    };
  },

  mixins: [deleteMixin, validationErrors],

  created() {
    this.loadBranch();
  },

  methods: {
    formatDatetime,

    async loadBranch() {
      this.loading = true;

      try {
        this.branch = await api.branches.getById(this.$route.params.id);
        this.$store.commit('setBreadcrumbLabel', {
          routeName: 'branchesDetail',
          label: this.branch.name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: 'franchisesIndex' });
      }

      this.loading = false;
    },

    integerToCurrency(amount) {
      if (amount == null) {
        return "-";
      }

      const formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
      });

      return formatter.format(amount);
    },

    getOptions() {
      let options = [];

      if (this.hasPermission("edit_branches")) {
        options.push({
          action: "edit",
          label: "Editar",
        });
      }

      if (this.hasPermission("delete_branches")) {
        options.push({
          action: "delete",
          label: "Eliminar",
        });
      }

      return options;
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.branches.delete(this.branch.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        await this.$store.dispatch("loadUser");
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: 'franchisesIndex' });
      }

      this.loadingDelete = false;
    },
  },

  watch: {
    selectedBranch() {
      this.loadBranch();
    },
  },
};
</script>